import { render, staticRenderFns } from "./RsaPazienteSocioRiabilitativoPTIEditComponent.vue?vue&type=template&id=7541e22d"
import script from "./RsaPazienteSocioRiabilitativoPTIEditComponent.vue?vue&type=script&lang=js"
export * from "./RsaPazienteSocioRiabilitativoPTIEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports